import sharedMutations from "@/store/utils/shared-mutations";
import { Payment } from "@/models";

const CLEAR_PROMO_CODE = state => (state.promoCode = new Payment({}));

const CLEAR_PAYMENT_HISTORY = state => (state.paymentHistories = []);

export default {
  ...sharedMutations,
  CLEAR_PROMO_CODE,
  CLEAR_PAYMENT_HISTORY
};
